module.exports = __webpack_public_path__ + "img/dispatch-wo-button.56b9489e.svg";